var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('k-dropdown',{class:[_vm.css.kd, ( _obj = {}, _obj[_vm.css.active] = _vm.show, _obj )],attrs:{"show":_vm.visible,"gap":"0","trigger":"hover","alignment":"left","bodyClassName":_vm.css.body,"title":_vm.rTitle(),"white-list":_vm.wh,"body":_vm.rBody()},on:{"update:show":function($event){_vm.visible=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }